import Footer from "./parts/footer"
import HeaderInternal from "./parts/header-internal"

function Congratulations() {
    return (
        <>
            <HeaderInternal />
            <div className="container w-full max-w-screen-sm m-auto my-16">
                <article>
                    <h1>Ваша реєстрація на HR Wisdom Summit 2027 пройшла успішно!</h1>
                    
                    <p>
                        Ми раді вітати вас серед майбутніх учасників заходу, який об'єднує людей, відкритих до нових знань, партнерств і можливостей.
                    </p>
                    
                    <p>
                        Щиро дякуємо вам за вашу стійкість, силу та внесок у розвиток нашої країни. Ваш досвід та прагнення рухатися вперед надихають і роблять нашу спільноту сильнішою.
                    </p>
                    
                    <p>
                        Ваша участь у HR Wisdom Summit 2027 є для нас надзвичайно важливою. Реєстрація на саміт наразі є попередньою. Ближче до дати проведення ми надішлемо вам нагадування про захід з організаційною інформацією, а також попросимо підтвердити свою участь.
                    </p>
                    
                    <p>
                        <b>Дякуємо, що ви з нами!</b>
                    </p>
                </article>
            </div>
            <Footer />
        </>

    )
}

export default Congratulations;